import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'truncated',
})
export class TruncatedPipe implements PipeTransform {
	transform(value: string, max: number = 10): boolean {
		const result = value.split(' ').splice(0, max).join(' ');
		return result.length < value.length;
	}
}
